import React from 'react';
import { withApollo } from 'react-apollo';
import { useMutation } from '@apollo/react-hooks';
import { DELETE_SENDER } from '../../../mutation/mutation';
import { GET_BOX_DATA } from '../../../query/query';

const Sender = ({ sender, boxId }) => {
  const [deleteSenderMutation] = useMutation(DELETE_SENDER, {
    update(cache, { data: { savDeleteSender } }) {
      if (!savDeleteSender) return;
      const { savGetBoxData } = cache.readQuery({
        query: GET_BOX_DATA,
        variables: { boxId },
      });
      savGetBoxData.senders = savGetBoxData.senders.filter((_sender) => _sender !== sender);
      cache.writeQuery({ query: GET_BOX_DATA, variables: { boxId }, data: { savGetBoxData } });
    },
  });

  const deleteSender = () => {
    // eslint-disable-next-line no-alert
    const confirm = window.confirm(`⚠️ Are you sure to delete ${sender} as sender of the box ?`);
    if (!confirm) {
      return;
    }

    deleteSenderMutation({ variables: { boxId, senderEmail: sender } });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <a href={`/user/${sender}/${boxId}`} key={sender}>{sender}</a>
      {/* eslint-disable-next-line */}
      <a
        onClick={deleteSender}
        style={{
          fontSize: 12, alignSelf: 'center', marginLeft: 10, cursor: 'pointer',
        }}
      >
        <span role="img" aria-label="red=cross">❌</span>
      </a>
    </div>
  );
};

export default withApollo(Sender);



// WEBPACK FOOTER //
// ./src/components/sav-lovebox/infos/sender.js